var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasury(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2574 15.8534L32.5764 5.43247L37.9499 15.8534H27.2574ZM27.6373 17.319H37.5156C34.7474 19.9245 30.4595 19.9245 27.6373 17.319ZM13.7421 15.8534H3.04932L8.36832 5.43247L13.7421 15.8534ZM3.42985 17.319H13.3082C10.54 19.9245 6.252 19.9787 3.42985 17.319ZM32.5765 2.17542L21.2323 2.22965V0.275635H19.7667V2.22965L8.36823 2.17542L0.932129 16.6677C4.89432 22.0955 11.8967 22.2582 15.8039 16.6677L9.182 3.80433H19.766V29.2602H13.7414V30.7258H26.7678V29.2602H21.2316V3.80433H31.7612L25.1936 16.6677C29.0473 22.1498 36.1028 22.2039 40.011 16.6677L32.5749 2.17542H32.5765Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasury);
export default __webpack_public_path__ + "static/media/treasury.ccb344670078f3e7dbaea69ae7294efb.svg";
export { ForwardRef as ReactComponent };